import { render, staticRenderFns } from "./TaxTypes.vue?vue&type=template&id=e6ebc2c6"
import script from "./TaxTypes.vue?vue&type=script&lang=js"
export * from "./TaxTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports